import { MAP_TYPES } from '@deck.gl/carto';

const TRACT_BROADBAND_SOURCE_ID = 'tractBroadbandSource';

function source(year) {
  year = parseInt(year);

  return {
    id: TRACT_BROADBAND_SOURCE_ID,
    type: MAP_TYPES.QUERY,
    connection: 'carto_dw',
    data: `
      SELECT
        broadband, year, geom, tracts.tractcode, ST_X(ST_CENTROID(geom)) AS lng, ST_Y(ST_CENTROID(geom)) AS lat, tracts.countyname AS countyname, tracts.statename AS statename, "tract" AS type
      FROM
        carto-dw-ac-cn5bemsi.shared.tract_observations AS observations
      JOIN
        carto-dw-ac-cn5bemsi.shared.tract_geometries AS geometry ON observations.geoid = geometry.geoid
      JOIN
        carto-dw-ac-cn5bemsi.shared.tracts AS tracts ON geometry.geoid = tracts.geoid
      WHERE
        observations.year = ${year}
    `,
    queryParameters: {
      year,
    },
  };
}

export default source;
